<template>
  <div id="featured-section" class="container-fluid">
    <div class="bgicons" v-if="!$parent.isMobile">
      <embed class="icon-star-and-cin" src="https://flxassets.s3-accelerate.amazonaws.com/2018/images/icon-star-and-cin.svg" type="image/svg+xml">
      <embed class="icon-soda" src="https://flxassets.s3-accelerate.amazonaws.com/2018/images/icon-soda.svg" type="image/svg+xml">
    </div>
<template v-for="(cat,ic) in $parent.lang.movies">

    <div class="row cats"
         v-if="(ic === 'free' && $parent.platform === 'web' || ic !== 'free')"
         v-bind:key="ic">
      <div class="col-md-12 title-trending">
        <template v-if="ic === 'free'">
          <a :href="($parent.currentLang === 'es' ? '/gratis/' : '/free/' )">
            <h1 class="bold-font nrlslstxtyn" style="color: #010e23;" v-html="cat.genre"></h1>
          </a>
        </template>
        <h1 v-else class="bold-font nrlslstxtyn" v-html="cat.genre"></h1>
      </div>
      <div class="controlp">
        <img class="prev" alt="Prev" src="https://flixlatino.com/img/left.png" @click="prev(ic)" v-if="pshow(ic)" />
        <img class="next" alt="Next" src="https://flixlatino.com/img/right.png" @click="next(ic,filter(cat.movies))" v-if="nshow(ic,filter(cat.movies))" />
      </div>
        <div class="col-md-12 carousel-list flowplayerfeatured p-0">
          <div class="caru carousel row no-gutters">

            <div class="slide col-xs-6  col-sm-6 col-md-4 col-lg-2 "
                  v-for="(mov,movic) in filter(cat.movies,ic).movies"
                  v-bind:key="movic"
                  :id="'free'+ic+mov.id"
                  data-type="undefined"
                  :data-source="mov.video"
                  :data-poster="mov.thumb"
                  v-on:slideclick="goto('/title/'+mov.slug)">


              <template v-if="ic == 'free'">
                <template v-if="$parent.platform == 'web' ">
                <a :id="'free-button'+ic+mov.id" v-bind:key="'a-'+limit+mov.id"
                   :href="($parent.currentLang === 'es' ? '/gratis/' : '/free/' )+'#'+mov.slug"
                >
                  <img class="img-weekly " width="219" height="123" v-bind:key="'img-'+limit+mov.id" v-lazyload :alt="(mov.title_keywords ? mov.title_keywords : mov.title)" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')"  :data-src="mov.thumb" >
                </a>
                  <span class="title-promo m-1" v-html="mov.title" ></span>
                </template>
              </template>
              <template v-else>
                <a :id="'free-button'+ic+mov.id" v-bind:key="'a-'+limit+mov.id"
                   :href="'/'+titleUrl(mov)"
                >
                  <img class="img-weekly " width="219" height="123" v-bind:key="'img-'+limit+mov.id" v-lazyload :alt="(mov.title_keywords ? mov.title_keywords : mov.title)" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')"  :data-src="mov.thumb" >
                </a>
                <span class="title-promo m-1" v-html="mov.title" ></span>
              </template>



            </div>
          </div>
        </div>
    </div>
</template>


</div>
</template>


<script>

// import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'flixSampleTwo',
  components: {
    // Carousel, Slide
  },
  data(){ return {
        pages:[],
        limit: 10,
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
          loop: true,
          loopFillGroupWithBlank: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
  },
  created: function () {
    window.onresize = this.size;
    this.size();
    // this.lang = lang.es;
    // this.movies = lang.movies;
  },
  updated: function(){
  },
  computed:{

  },
  methods:{
    titleUrl: function(movie){
      let url = "";

      switch (movie.type) {
        case 'movie':
        case 'movies':
          url = (this.$parent.currentLang === 'es' ? 'peliculas' : 'movies' )+"/"+movie.slug;
          break;
        case 'series':
          url = "series/"+(this.$parent.currentLang === 'es' ? movie.slug : movie.slug+'/en/' );
          break;
        case 'kids':
          let movie_slug = movie.slug.split('/')[1];
          url = (this.$parent.currentLang === 'es' ? 'animados/'+movie_slug : 'animated/'+movie_slug );
          break;
        default:
          url = 'title/'+movie.slug;
      }

      return url;
    },
    pshow: function(ic){
      return (this.pages[ic] > 0 ? true : false)
    },
    nshow: function(ic,movies){
      return (this.pages[ic] > movies.total || this.limit > movies.total || this.pages[ic] + this.limit == movies.total ? false : true)
    },
    prev: function(ic){
      if (this.pages[ic] > 0){
        this.pages[ic]--
      }
    },
    next: function(ic,movies){
      if (this.pages[ic] + this.limit < movies.total){
        this.pages[ic]++
      }

    },
    size: function(){
      if  (window.outerWidth <= 575){
        this.limit = 1;
      }else if(window.outerWidth > 575 && window.outerWidth < 768){
        this.limit = 2;
      }else if(window.outerWidth >= 768 && window.outerWidth < 991){
        this.limit = 3;
      }else if(window.outerWidth >= 991){
        this.limit = 6;
      }
    },
    goto: function(url){
      window.location.href=url;
    },
    filter: function(movies,cat){

      if (!this.pages[cat]){
        this.$set(this.pages, cat, 0)
      }

      let moviesPack = {
        movies: movies.slice(this.pages[cat], this.limit + this.pages[cat]),
        total: movies.length
      }
      return moviesPack;
    }


  }
  
}
</script>


